import { render, staticRenderFns } from "./EditNotaCliente.vue?vue&type=template&id=7d825640&scoped=true"
import script from "./EditNotaCliente.vue?vue&type=script&lang=js"
export * from "./EditNotaCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d825640",
  null
  
)

export default component.exports